import { EarStyle, Neckline } from '@drycut/graphql';
import { Para, Stack } from '@drycut/ui-components';

import ControlledNumberField from './ControlledNumberField';
import ControlledSelectInput from './ControlledSelectInput';

export default function ShortHairOptions(): React.ReactElement {
  const EarStyles: Record<EarStyle, string> = {
    [EarStyle.NotDefined]: '—',
    [EarStyle.Uncovered]: 'frei',
    [EarStyle.Covered]: 'bedeckt',
  };

  const NeckLines: Record<Neckline, string> = {
    [Neckline.NotDefined]: '—',
    [Neckline.Straight]: 'gerade',
    [Neckline.Tapered]: 'auslaufend',
  };

  const necklineOptions = Object.keys(NeckLines).map((key) => ({
    value: key,
    label: NeckLines[key as Neckline],
  }));

  const earsOptions = Object.keys(EarStyles).map((key) => ({
    value: key,
    label: EarStyles[key as EarStyle],
  }));

  return (
    <Stack gap={2} className="w-full">
      <Stack direction="row" className="w-full flex justify-between">
        <Para as="label" htmlFor="lengthSides">
          Länge Seite
        </Para>

        <div>
          <ControlledNumberField name="lengthSides" />
        </div>
      </Stack>

      <Stack direction="row" className="w-full flex justify-between">
        <Para as="label" htmlFor="lengthTop">
          Länge oben
        </Para>

        <div>
          <ControlledNumberField name="lengthTop" />
        </div>
      </Stack>

      <Stack direction="row" className="w-full flex justify-between">
        <Para as="label" htmlFor="ears">
          Ohren
        </Para>

        <ControlledSelectInput name="ears" options={earsOptions} />
      </Stack>

      <Stack direction="row" className="w-full flex justify-between">
        <Para>Nacken</Para>

        <ControlledSelectInput name="neckline" options={necklineOptions} />
      </Stack>
    </Stack>
  );
}
